export default __webpack_public_path__ + "static/media/Ionicons.3517aeaa.ttf";